
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-content modal-content-width border-all-10px-modal">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header padding-bottom-0px">
      <div class="row">
        <div class="col-md-3">
          Patient Search
        </div>
        


        <div class="offset-md-8 col-md-1 padding-left-0px">
          <button *ngIf="Frombills" type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.close('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <button *ngIf="NotFrombills" type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px ">

      <ul class="nav nav-tabs nav-tab-service2 margin-top-13px" id="tabContent">
        <li class="active margin-right-15px"><a class="nav-itemerp active" href="#Search" data-toggle="tab">All Patients</a></li>
        <li class="margin-right-15px"><a class="nav-itemerp" href="#Guest" data-toggle="tab">Guest</a></li>

      </ul>
      <!--<div class="row margin-top-10 margin-bottom-10px margin-left-10px">
    <div class="col-md-5">
      <input type="text" class="form-control" placeholder="Search by Name,Gender,Phone Number" (input)="criteriaChange($event.target.value)">

    </div>



  </div>-->
      <div class="tab-content">
        <div class="tab-pane active" id="Search">
          <div class="card">
            <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
              <div class="row">
               
                  <div class="offset-md-3 col-md-8 float-right padding-right-0px padding-l-0px display-inherit">
                    <form novalidate="" #f="ngForm" class="display-inherit margin-left-auto">
                      <!--<input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">-->
                      <div class="clear-form">
                        <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                        <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                      </div>
                      <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
                    </form>
                  </div>
               
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px counselling-modal">
                      <div class="table-component">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped margin-left-zero "
                                 cols="auto,2*,*,*,*,*,*,*">

                            <thead class="">
                              <tr>
                                <th></th>
                                <th class="">
                                  PID
                                </th>
                                <!--<th class="text-align-center">Day</th>-->

                                <th class="text-align-center">
                                  Old Reg No
                                </th>
                                <th class="">
                                  Name
                                </th>
                                <!--<th class="text-align-center">Start Time</th>-->
                                <th class="">
                                  Reg Date
                                </th>

                                <!--<th class="">
                    Prime Relation
                  </th>-->

                                <th class="">
                                  Contact
                                </th>
                                <th class="">
                                  Sex
                                </th>
                                <th class="">Age</th>

                                <th>Marital </th>
                                <th>Category</th>




                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                                <td class="padding-all-0px">
                                  <button *ngIf="PATIENT_FORMATTED_CODE"
                                          type="button" class="btn font-size-13px actions-btn-prime" (click)="Guest(l.FormattedCode,'Registered')">
                                    Select
                                  </button>
                                  <button *ngIf="PATIENT_OBJ"
                                          type="button" class="btn font-size-13px actions-btn-prime" (click)="activeModal.close(l)">
                                    Sel..
                                  </button>
                                </td>
                                <td class="padding-all-0px"> <a (click)="ViewPatientDetails(l)" class="nav-link-hand">{{l.FormattedCode}}</a>  </td>
                                <!--<td class="td-padding text-align-center">Mon</td>-->
                                <td class="td-padding text-align-center">

                                  {{l.PatientRegistrationNumber}}
                                </td>
                                <td class="padding-top-0px padding-bottom-0px">{{l.DisplayName}}</td>
                                <!--<td class="td-padding text-align-center"></td>-->
                                <td class="padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">{{l.RegistrationDate| date:'MMM-dd-yyyy'}}</td>
                                <!--<td class="  ">{{l.PrimeRelation}}</td>-->

                                <td class="padding-top-0px padding-bottom-0px">{{l.Telephone1}}</td>
                                <td class="padding-top-0px padding-bottom-0px">{{l.Gender}}</td>
                                <td class="padding-top-0px padding-bottom-0px">{{l.Age}}</td>

                                <td class="padding-top-0px padding-bottom-0px">{{l.MaritalStatus}}</td>
                                <td class="padding-top-0px padding-bottom-0px">{{l.PatientCategory}}</td>






                              </tr>

                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <!--<div class="card-footer text-align-center">
          <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
        </div>-->
          </div>


        </div>

        <div class="tab-pane" id="Guest">

          <div class="row">
            <div class="col-md-12 padding-l-0px">
              <form class="form" novalidate=""  #f="ngForm">
                <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                  <div class="card-body ">

                    <div class="row">
                      <div class="col-md-12">


                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 text-align-right">
                                <label for="firstName" class="margin-bottom-0px margin-top-5px"> Name </label>
                              </div>
                              <div class="col-md-2">
                                <CodeTypeValue CodeType="NPRE"
                                               id="GuestSalutation" PassType="Long"
                                               [(ngModel)]="GuestSalutation" SelectedValue="{{GuestSalutation}}"
                                               name="GuestSalutation" required #Prefix="ngModel">
                                </CodeTypeValue>
                                <!--<input type="text" class="form-control" placeholder="Salutation"
                                       id="GuestSalutation"
                                       [(ngModel)]="GuestSalutation"
                                       name="GuestSalutation" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                       maxlength="30" minlength="1" #VName="ngModel" required>-->
                              

                              </div>
                              <div class="col-md-4">

                                <input type="text" class="form-control" placeholder="Name"
                                       id="GuestName"
                                       [(ngModel)]="GuestName"
                                       name="GuestName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                       maxlength="30" minlength="1" #VName="ngModel" required>
                                <small class="form-text text-danger"
                                       *ngIf="(!VName.valid && (VName.dirty || VName.touched) && VName.errors.required )">(Field cannot be left blank)</small>
                                <small class="form-text text-danger"
                                       *ngIf="(!VName.valid && VName.errors.pattern)">(special characters are not allowed)</small>

                              </div>

                            </div>

                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 text-align-right">
                                <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Mobile Phone </label>
                              </div>
                              <div class="col-md-3">
                                <input type="tel" class="form-control" placeholder="Mobile Phone"
                                       id="GuestPhone"
                                       [(ngModel)]="GuestPhone"
                                       maxlength="25" minlength="1"
                                       name="GuestPhone" #phone1="ngModel">
                                <!--<small class="form-text text-danger"
                             *ngIf="(!phone1.valid && (phone1.dirty || phone1.touched) && phone1.errors.required )">(Field cannot be left blank)</small>-->
                                <!--<small class="form-text text-danger"
                                       *ngIf="(!phone1.valid)">(Provide Valid CellNo)</small>-->
                              </div>
                            </div>


                          </div>
                        </div>



                        



                      </div>


                    </div>
                  </div>
                  <div class="card-footer">
                    <!--<button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>-->
                    <button (click)="Guest(null,'Guest')" type="button" class="btn actions-btn-prime float-right font-size-13px" >Save</button>
                  </div>
                </div>
              </form>
            </div>
          </div>





        </div>

        









      </div>
      


    </div>
    <!--<div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>

    </div>-->

  </div>
</div>
